import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appliedGroup: null,
  appliedProperties: [],
  // Everything selected by default, in report page order.
  appliedSections: [
    "lead_conversion",
    "t12_occupancy",
    "t12_leasing",
    "t12_avg_days_vacant",
    "comparative_pnl",
    "aggregated_pnl",
    "current_rent_roll",
    "pnl_report",
    "cashflow_statement",
    "budget_variance",
    "work_order_summary",
  ],
  selectedPeriod: "t12",
  startDate: null,
  endDate: null,
};

const ownerReportFilterSlice = createSlice({
  name: "ownerReportFilter",
  initialState,
  reducers: {
    setOwnerReportFilters: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetOwnerReportFilters: () => initialState,
  },
});

export const { setOwnerReportFilters, resetOwnerReportFilters } =
  ownerReportFilterSlice.actions;
export default ownerReportFilterSlice.reducer;
